import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const { REACT_APP_API_ENDPOINT } = process.env;

export const getOfficeDetail = createAsyncThunk(
  "get/office/detail",
  async (args) => {
    const resp = await axios.get(
      `${REACT_APP_API_ENDPOINT}/api/v2/posts/office/${args.id}`
    );
    return resp.data;
  }
);

const initialState = {
  officeDetail: {},
};

const OfficeDetailSlice = createSlice({
  name: "OfficeDetail",
  initialState,
  reducers: {
    resetState: () => initialState,
  },
  extraReducers: {
    [getOfficeDetail.fulfilled]: (state, action) => {
      state.officeDetail = action.payload;
    },
    [getOfficeDetail.rejected]: () => {
      alert("Get office failed!");
    },
  },
});

export default OfficeDetailSlice.reducer;
